export default "__VITE_ASSET__BjBS6SWT__"